import { render, staticRenderFns } from "./FastdeliTransfer.vue?vue&type=template&id=40f74201&scoped=true&"
import script from "./FastdeliTransfer.vue?vue&type=script&lang=js&"
export * from "./FastdeliTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f74201",
  null
  
)

export default component.exports